<template>
    <div class="-mx-4 flex border-b border-theme-border">
        <button
            v-for="tab in tabs"
            :key="tab.id"
            class="flex flex-1 cursor-pointer items-center justify-center gap-2 border-b-2 border-transparent bg-transparent px-2 py-2.5 text-sm font-medium text-gray-500 transition-colors hover:text-gray-700 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 dark:text-gray-400 dark:hover:text-gray-300"
            :class="{
                'border-blue-500 text-blue-500 dark:border-purple-500 dark:text-purple-400': tab.isActive,
            }"
            @click="tab.action"
        >
            {{ tab.label }}
            <span class="text-xs font-normal text-gray-400">{{ tab.count }}</span>
        </button>
    </div>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'selections']),
        ...mapGetters(['showHighlightsAndNotes']),

        highlightsCount() {
            return this.selections.filter(selection => !selection.hasAnnotation).length;
        },

        notesCount() {
            return this.selections.filter(selection => selection.hasAnnotation).length;
        },

        tabs() {
            return [
                {
                    id: 'all',
                    label: this.localizations[this.lang].all,
                    count: this.selections.length,
                    isActive: this.showHighlightsAndNotes,
                    action: this.showHighlightsAndNotesTab,
                },
                {
                    id: 'highlights',
                    label: this.localizations[this.lang].highlights,
                    count: this.highlightsCount,
                    isActive: this.ui.features.highlights.opened,
                    action: this.toggleHighlights,
                },
                {
                    id: 'notes',
                    label: this.localizations[this.lang].notes,
                    count: this.notesCount,
                    isActive: this.ui.features.notes.opened,
                    action: this.toggleNotes,
                },
            ];
        },
    },
    methods: {
        ...mapActions(['toggleHighlights', 'toggleNotes', 'showHighlightsAndNotesTab']),
    },
};
</script>
